import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Divider, Grid, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { colors, URL } from "../utils/constant";
import { Language, language } from "../Languages/Language";
import usePatientDetails from "../data/talons/PatientDetails/usePatientDetails";
import { useAuth } from "../data/talons/auth/useAuth";
import VisitNavbar from "../component/VisitNavbar";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { getApiData } from "../data/selector/auth.selector";
import GlobalPageLoader from "../data/talons/loader/useFullPageLoader";
import {
  getLanguage,
  getLanguageNumber,
} from "../data/selector/language.selector";
import { getUserToken } from "../data/selector/appState.selector";
import { setSelectedLanguage } from "../data/reducer/language.reducer";
import { English } from "../Languages/en";
import { Spanish } from "../Languages/sp";
import { size } from "lodash";

export default function PatientDetails() {
  // const { autoLogout } = useAuth();
  const apiData = useSelector(getApiData);
  const Language = useSelector(getLanguage);
  // const { inactivityTimeout, handleMouseMove, isActive } = autoLogout();
  const { SubjectDetails, fetchPatientDetails } = usePatientDetails();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const number = useSelector(getLanguageNumber);

  useEffect(() => {
    // console.log(dropdownValue, "vkvkvkv");
    if (!number) {
      // console.log("noneWnglish");
      dispatch(setSelectedLanguage(English));
    } else if (number == 1) {
      // console.log("english");
      dispatch(setSelectedLanguage(English));
    } else if (number == 2) {
      // console.log("spanish");
      dispatch(setSelectedLanguage(Spanish));
    }
    // dispatch(setSelectedLanguage(Spanish));
    // console.log("nnnn");
  }, [number]);
  const token = useSelector(getUserToken);
  useEffect(() => {
    if (size(token) === 0) {
      navigate(URL.login);
    }
  }, [token]);

  return (
    <>
      {GlobalPageLoader()}
      <VisitNavbar />
      <Header />

      <Box
        sx={{
          pt: 7,
          backgroundColor: "",
          marginLeft: "67px",
          height: "fit-content",
        }}
      >
        <Typography variant="h4" className="px-4   my-3 fw-bold">
          {Language.Patient?.patient_Head}
        </Typography>
        <Grid
          className="d-flex justify-content-center align-items-center"
          sx={{ pb: 5 }}
        >
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            style={{
              height: "80vh",
              width: "40%",
              backgroundColor: "white",
            }}
          >
            <Grid item xs={6} className="px-4  m-0">
              <Stack className="fw-bold .">{Language.Patient.studyTitle}</Stack>
              <Stack> {SubjectDetails?.StudyTitle}</Stack>
            </Grid>
            <Grid item xs={6} className="px-4  m-0 ">
              <Stack className="fw-bold">
                {Language.NavbarTitle.patient_num}
              </Stack>
              <Stack className="mb-3"> {SubjectDetails?.SubjectInfoId}</Stack>
            </Grid>
            <Divider style={{ width: "100%", color: "" }} />
            <Grid item xs={6} className="px-4  m-0  ">
              <Stack className="fw-bold"> {Language.Patient.siteId}</Stack>
              <Stack>
                {" "}
                {SubjectDetails?.SiteName}/ {SubjectDetails?.SiteId}
              </Stack>
            </Grid>
            <Grid item xs={6} className="px-4  m-0 ">
              <Stack className="fw-bold">
                {" "}
                {Language.Patient.investigator_Name}
              </Stack>
              <Stack>
                {" "}
                {SubjectDetails?.InvestigatorName
                  ? SubjectDetails?.InvestigatorName
                  : "-"}
              </Stack>
            </Grid>
            <Divider style={{ width: "100%", color: "" }} />
            <Grid item xs={6} className="px-4  m-0  ">
              <Stack className="fw-bold"> {Language.Patient.siteAdd}</Stack>
              <Stack>
                {" "}
                {SubjectDetails?.SiteAddress === "" &&
                SubjectDetails?.SiteContactNo === ""
                  ? "-"
                  : `${SubjectDetails?.SiteAddress} ${SubjectDetails?.SiteContactNo}`}
              </Stack>
            </Grid>
            <Grid item xs={6} className="px-4  m-0 ">
              <Stack className="fw-bold">
                {" "}
                {Language.Patient.screeningDate}
              </Stack>
              <Stack> {SubjectDetails?.DateOfRandomization}</Stack>
            </Grid>
            {/* <Divider style={{ width: "100%", color: "" }} /> */}
            {/* <Grid item xs={6} className="px-4  m-0  ">
              <Stack className="fw-bold">
                {" "}
                {Language.Patient.screening_Number}
              </Stack>
              <Stack>
                {" "}
                {SubjectDetails?.RandomizationNo === null
                  ? "-"
                  : `${SubjectDetails?.RandomizationNo}`}
              </Stack>
            </Grid> */}
            <Grid item xs={6}></Grid>
            <Grid
              item
              xs={8}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Button
                fullWidth
                type="button"
                variant="contained"
                sx={{
                  borderRadius: "0px",
                  mt: 1,
                  mb: 2,
                  backgroundColor: colors.blue,
                  "&:hover": {
                    backgroundColor: colors.blue,
                  },
                }}
                onClick={() => navigate(URL.instruction)}
              >
                {Language.LoginTitle.proceed_btnText}
              </Button>
            </Grid>
          </Grid>
          <Footer />
        </Grid>
      </Box>
    </>
  );
}
